import styled from 'styled-components';

export const StyledOpenCallControllerContainer = styled.div`
    ${() => `
    background-color: rgba(32, 35, 50, 0.9);
    width: 570px;
    height: 90px;
    border-radius: 16px;

    display: flex;
    align-items: center;
    justify-content: space-around;
    column-gap: 30px;

    position: -webkit-sticky;
    position: fixed;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    bottom: 10px;
    text-align: center;

    opacity: 1;
    transition: opacity .2s ease-out;

    &:hover {
        opacity: 1;
    }
    `}
`;

export const StyledActivityCheckBoxContainer = styled.div`
    ${() => `
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        column-gap: 10px;
        margin-right: 16px;
        cursor: pointer;
    `}
`;
